import React from "react";
import { connect } from "react-redux";
import { Loading } from "../..";
import { openMobileMenu } from "../../../redux/actions/appActions";
import { loadSportTypes } from "../../../redux/actions/sportTypesActions";
import {
  clearSportEvents,
  loadKironEvents,
  getKironEvent,
} from "../../../redux/actions/sportEventsActions";
import { SportIcon } from "../../";
import { Menu, Drawer } from "antd";
import moment from "moment";
import { useMediaQuery } from "react-responsive";

const IsMiddleScreenAndMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 1000 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1000 });
  return isDesktop ? children : null;
};
const Title = (props) => {
  const { feedId, sportId, text } = props;

  return (
    <div className="title">
      <SportIcon feedId={feedId} sportId={sportId} />
      <div className="text">{text}</div>
    </div>
  );
};

const KironTitle = (props) => {
  const { feedId, sportId, date, gameId } = props;
  let dateArr = date.split(" ");
  let newDate = moment(`${dateArr[2]} ${dateArr[0]}`, "DD/MM/YYYY HH:mm");

  return (
    <div className="title" style={{ justifyContent: "space-evenly" }}>
      <div className="text">{newDate.format("DD/MM/YYYY HH:mm")}</div>

      <div className="text">{gameId}</div>
    </div>
  );
};

class VirtualMenu extends React.Component {
  state = {
    selectedKeys: [],
  };

  componentDidUpdate(prevProps) {
    if (
      (prevProps.appMatch &&
        prevProps.appMatch.url !== this.props.appMatch.url) ||
      (!prevProps.connected && this.props.connected)
    ) {
      let request = {
        Data: {
          Feed: { FeedId: Number(this.props.match.params.feed) },
        },
      };
      this.props.loadSportTypes(request);
      this.handleOpenTree();
    }
  }

  handleOpenTree() {
    const { tournamentData, appMatch, match } = this.props;

    let matchTemp = appMatch ? appMatch : match;
    let selectedKeys = [];
    let sport = matchTemp.params.sport;
    let feed = matchTemp.params.feed;

    selectedKeys.push(`${sport},${feed}`);

    this.setState({
      selectedKeys,
    });
  }

  async componentDidMount() {
    const { loadSportTypes, match, connected } = this.props;
    if (connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
        },
      };
      loadSportTypes(request);
    }
    this.handleOpenTree();
  }

  onSportTypeClick = (item) => {
    const { history, clearSportEvents, feedName, openMobileMenu } = this.props;
    const path = `/${feedName}/${item.feed.feedId}/${item.sport.sportId}/${
      item.sport.sportDisplayName
    }`;
    clearSportEvents();
    openMobileMenu(false);
    history.push(path);
  };

  onKironSportTypeClick = (item) => {
    const { history, clearSportEvents, feedName, getKironEvent } = this.props;
    const path = `/${feedName}/${item.feed.feedId}/${item.sport.sportId}/${
      item.kironEventNumber
    }/${item.eventId}`;
    //clearSportEvents();
    history.push(path);
    this.handleOpenTree();
  };

  loadEvents = (item) => {
    const { match, loadKironEvents } = this.props;

    if (item.feed.feedId.toString() !== match.params.feed) {
      let Data = {
        Feed: {
          FeedId: Number(item.feed.feedId),
        },
        Sport: {
          SportId: Number(item.sport.sportId),
        },
      };
      loadKironEvents({ Data });
    }
  };
  render() {
    const {
      sportTypes,
      loadingSportTypes,
      error,
      appMatch,
      events,
      openMobileMenu,
      mobileMenuOpen,
    } = this.props;

    if (error) {
      return <div>{error}</div>;
    }

    return (
      <div>
        {loadingSportTypes && <Loading />}

        {!loadingSportTypes && sportTypes && sportTypes.length > 0 && (
          <>
            <IsDesktop>
              <Menu
                className="menu virtual-menu"
                mode="inline"
                selectedKeys={this.state.selectedKeys}
              >
                <div className="menu-banner">Virtual Sports</div>

                {sportTypes.map((item, index) => {
                  return (
                    // item.feed.feedId == 10 ?
                    // //(permissions && permissions[Enums.Permissions.SpinAndWin] && permissions[Enums.Permissions.SpinAndWin].isAllowed ? // check if have permission for spin&win

                    // 	<Menu.SubMenu
                    // 		className="sw sub-menu"
                    // 		title={<Title text={item.sport.sportDisplayName} feedId={item.feed.feedId} sportId={item.sport.sportId} />}
                    // 		onTitleClick={() => this.loadEvents(item)}
                    // 		key={`${item.sport.sportId},${item.feed.feedId}`}>

                    // 		{
                    // 			(appMatch.params.feed === "10") && Object.values(events).length > 0 && Object.values(events).map((item, i) =>
                    // 				<Menu.Item
                    // 					disabled={!item.enableBet}
                    // 					key={`${item.eventId},${item.kironEventNumber}`}
                    // 					className="item ant-menu-submenu"
                    // 					onClick={() => this.onKironSportTypeClick(item)}>
                    // 					<KironTitle date={item.eventDateOfMatchFormated} gameId={item.kironEventNumber}></KironTitle>
                    // 				</Menu.Item>
                    // 			)
                    // 		}
                    // 	</Menu.SubMenu>
                    // 	//:
                    // 	//null)
                    // 	:
                    <Menu.Item
                      key={`${item.sport.sportId},${item.feed.feedId}`}
                      className="item ant-menu-submenu"
                      onClick={() => this.onSportTypeClick(item)}
                    >
                      <Title
                        text={item.sport.sportDisplayName}
                        feedId={item.feed.feedId}
                        sportId={item.sport.sportId}
                      />
                    </Menu.Item>
                  );
                })}
              </Menu>
            </IsDesktop>
            <IsMiddleScreenAndMobile>
              <Drawer
                width={220}
                className="mobile"
                placement="left"
                closable={false}
                onClose={() => openMobileMenu(false)}
                visible={mobileMenuOpen}
              >
                <Menu className="menu virtual-menu" mode="inline">
                  <div className="menu-banner">Virtual Sports</div>

                  {sportTypes.map((item, index) => {
                    return (
                      // item.feed.feedId == 10 ?
                      // //(permissions && permissions[Enums.Permissions.SpinAndWin] && permissions[Enums.Permissions.SpinAndWin].isAllowed ? // check if have permission for spin&win

                      // 	<Menu.SubMenu
                      // 		className="sw sub-menu"
                      // 		title={<Title text={item.sport.sportDisplayName} feedId={item.feed.feedId} sportId={item.sport.sportId} />}
                      // 		onTitleClick={() => this.loadEvents(item)}
                      // 		key={`${item.sport.sportId},${item.feed.feedId}`}>

                      // 		{
                      // 			(appMatch.params.feed === "10") && Object.values(events).length > 0 && Object.values(events).map((item, i) =>
                      // 				<Menu.Item
                      // 					disabled={!item.enableBet}
                      // 					key={`${item.eventId},${item.kironEventNumber}`}
                      // 					className="item ant-menu-submenu"
                      // 					onClick={() => this.onKironSportTypeClick(item)}>
                      // 					<KironTitle date={item.eventDateOfMatchFormated} gameId={item.kironEventNumber}></KironTitle>
                      // 				</Menu.Item>
                      // 			)
                      // 		}
                      // 	</Menu.SubMenu>
                      // 	//:
                      // 	//null)
                      // 	:
                      <Menu.Item
                        key={`${item.sport.sportId},${item.feed.feedId}`}
                        className="item ant-menu-submenu"
                        onClick={() => this.onSportTypeClick(item)}
                      >
                        <Title
                          text={item.sport.sportDisplayName}
                          feedId={item.feed.feedId}
                          sportId={item.sport.sportId}
                        />
                      </Menu.Item>
                    );
                  })}
                </Menu>
              </Drawer>
            </IsMiddleScreenAndMobile>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sportTypes: state.sportTypes.sportTypes,
    loadingSportTypes: state.sportTypes.loadingSportTypes,
    error: state.sportTypes.error,
    feedName: state.app.feedName,
    appMatch: state.app.match,
    connected: state.signalr.virtualConnected,
    events: state.sportEvents.sportEvents,
    mobileMenuOpen: state.app.mobileMenuOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getKironEvent: (request) => {
      dispatch(getKironEvent(request));
    },
    loadKironEvents: (request) => {
      dispatch(loadKironEvents(request));
    },
    loadSportTypes: (request) => {
      dispatch(loadSportTypes(request));
    },
    clearSportEvents: () => {
      dispatch(clearSportEvents());
    },
    openMobileMenu: (open) => dispatch(openMobileMenu(open)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VirtualMenu);
